export function setLibraryPreviewVisibility(visible) {
    const previewArea = document.getElementById('libPreviewArea');
    if (previewArea) {
        previewArea.classList.toggle('hidden', !visible);
    }
    if (!visible) {
        const previewGrid = document.getElementById('libPreviewGrid');
        if (previewGrid) previewGrid.innerHTML = '';
        const previewFeedback = document.getElementById('libPreviewFeedback');
        if (previewFeedback) {
            previewFeedback.className = 'library-preview-feedback hidden';
            previewFeedback.innerText = '';
        }
        const previewCount = document.getElementById('libPreviewCount');
        if (previewCount) previewCount.innerText = '0';
        const previewLibraryName = document.getElementById('libPreviewLibraryName');
        if (previewLibraryName) previewLibraryName.innerText = 'Library';
        const previewCollapsedStrip = document.getElementById('libPreviewCollapsedStrip');
        if (previewCollapsedStrip) previewCollapsedStrip.innerHTML = '';
        const previewActions = document.getElementById('libPreviewActions');
        if (previewActions) {
            previewActions.classList.add('hidden');
            previewActions.innerHTML = '';
        }
        const previewBody = document.getElementById('libPreviewBody');
        if (previewBody) previewBody.classList.add('hidden');
        const previewSummary = document.getElementById('libPreviewCollapsedSummary');
        if (previewSummary) previewSummary.classList.add('hidden');
        const previewToggle = document.getElementById('libPreviewToggle');
        if (previewToggle) previewToggle.setAttribute('aria-expanded', 'false');
    }
}

function renderDropPreviewGrid(previews = []) {
    const grid = document.getElementById('libDropPreviewGrid');
    if (!grid) return 0;
    const values = Array.isArray(previews) ? previews : [];
    const hasValues = values.length > 0;
    const rows = 4;
    const gap = 2;
    const minCellSize = 24;

    // Reset previous inline sizing so each render measures fresh container size.
    grid.style.gridTemplateRows = '';
    grid.style.gridTemplateColumns = '';
    grid.style.gridAutoFlow = '';
    grid.style.width = '';
    grid.style.height = '';

    const host = grid.parentElement || grid;
    const hostHeight = host.clientHeight || 288;
    const hostWidth = host.clientWidth || 360;
    const style = window.getComputedStyle(grid);
    const frameX =
        (parseFloat(style.paddingLeft) || 0) +
        (parseFloat(style.paddingRight) || 0) +
        (parseFloat(style.borderLeftWidth) || 0) +
        (parseFloat(style.borderRightWidth) || 0);
    const frameY =
        (parseFloat(style.paddingTop) || 0) +
        (parseFloat(style.paddingBottom) || 0) +
        (parseFloat(style.borderTopWidth) || 0) +
        (parseFloat(style.borderBottomWidth) || 0);

    const availableWidth = Math.max(minCellSize, hostWidth - frameX);
    const availableHeight = Math.max(minCellSize * rows + gap * (rows - 1), hostHeight - frameY);
    // Lock to 4 full rows first (no whitespace above/below); then pack columns until side strip collision.
    let cell = Math.max(minCellSize, (availableHeight - gap * (rows - 1)) / rows);
    let columns = Math.floor((availableWidth + gap) / (cell + gap));
    if (!Number.isFinite(columns) || columns < 1) {
        columns = 1;
    }
    if (!Number.isFinite(cell) || cell <= 0) {
        columns = 1;
        cell = Math.max(minCellSize, availableWidth);
    }

    const cellCount = rows * columns;
    const gridWidth = columns * cell + gap * Math.max(columns - 1, 0);
    const gridHeight = rows * cell + gap * Math.max(rows - 1, 0);

    grid.style.gridTemplateRows = `repeat(${rows}, ${cell}px)`;
    grid.style.gridTemplateColumns = `repeat(${columns}, ${cell}px)`;
    grid.style.gridAutoFlow = 'row';
    grid.style.width = `${gridWidth + frameX}px`;
    grid.style.height = `${gridHeight + frameY}px`;

    grid.innerHTML = '';
    for (let i = 0; i < cellCount; i++) {
        const cell = document.createElement('div');
        cell.className = 'library-drop-preview-cell';
        if (hasValues) {
            const src = values[i];
            if (src) cell.style.backgroundImage = `url('${src}')`;
        }
        grid.appendChild(cell);
    }
    return cellCount;
}

export function setLibraryWorkspaceVisibility(libraries, _isAnonymous) {
    const stripSlot = document.querySelector('.tile-library-strip-slot');
    const uploadSlot = document.querySelector('.tile-library-upload-slot');
    const showStrip = Boolean(Array.isArray(libraries) && libraries.length > 0);
    if (stripSlot) stripSlot.classList.toggle('hidden', !showStrip);
    if (uploadSlot) uploadSlot.classList.toggle('full-width', !showStrip);
}

export function refreshLibraryDropLimitHint() {
    const subEl = document.getElementById('libDropSub');
    if (!subEl) return;
    subEl.textContent = '';
    subEl.classList.add('hidden');
}

export function setLibraryDropzoneState({ libraries = [], selectedLibraryId = null, onNeedPreviewFill = null } = {}) {
    const dropZone = document.getElementById('libDropZone');
    const labelRoot = document.getElementById('libDropLabel');
    const previewGrid = document.getElementById('libDropPreviewGrid');
    const titleEl = document.getElementById('libDropTitle');
    const subEl = document.getElementById('libDropSub');
    const overlay = document.getElementById('libDropOverlay');
    const overlayText = overlay ? overlay.querySelector('span') : null;
    const photosBtn = document.getElementById('libUploadPhotosBtn');
    const foldersBtn = document.getElementById('libUploadFoldersBtn');
    const overlayPhotosBtn = document.getElementById('libOverlayPhotosBtn');
    const overlayFoldersBtn = document.getElementById('libOverlayFoldersBtn');

    const lib = (libraries || []).find((item) => item.id === selectedLibraryId) || null;
    const hasSelectedLibrary = Boolean(lib && lib.id);

    if (dropZone) {
        dropZone.classList.toggle('disabled-zone', !hasSelectedLibrary);
    }
    if (labelRoot) {
        labelRoot.classList.toggle('hidden', hasSelectedLibrary);
    }
    if (previewGrid) {
        previewGrid.classList.toggle('hidden', !hasSelectedLibrary);
        if (hasSelectedLibrary) {
            const previews = Array.isArray(lib.previews) ? lib.previews : [];
            const requiredCells = renderDropPreviewGrid(previews);
            const tileCount = Math.max(0, Number(lib.tile_count || 0));
            if (
                typeof onNeedPreviewFill === 'function' &&
                tileCount > previews.length &&
                requiredCells > previews.length
            ) {
                onNeedPreviewFill(String(lib.id || ''), requiredCells);
            }
        }
    }
    if (titleEl) {
        const text = 'Create a new Tile Library.';
        titleEl.innerHTML = `<b>${text}</b>`;
    }
    if (subEl) {
        refreshLibraryDropLimitHint();
    }
    if (photosBtn) photosBtn.disabled = true;
    if (foldersBtn) foldersBtn.disabled = true;
    if (overlayPhotosBtn) overlayPhotosBtn.disabled = !hasSelectedLibrary;
    if (overlayFoldersBtn) overlayFoldersBtn.disabled = !hasSelectedLibrary;
    if (overlay) {
        overlay.classList.toggle('hidden', !hasSelectedLibrary);
    }
    if (overlayText && hasSelectedLibrary) {
        overlayText.textContent = '↻ Add more tiles';
    }
}
